/* eslint-disable max-lines */
import { generateTerms } from 'actions/identifier';
import LoadingIndicator from 'components/LoadingIndicator';
import { PLUS_ADD_FIELD_ICON } from 'constants/annotatorIcons';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getGeneratedTerms, getGeneratedTermsLoading } from 'selectors/identifier';
import { useSelector } from 'store';
import TermPill from './TermPill';

type ComponentProps = {
  inputName?: string;
  terms: string[];
  onChange: (term: string) => void;
  onDelete: (term: string) => void;
  enableGenerate?: boolean;
  // enableImport?: boolean;
  useDisabledColor?: boolean;
  required?: boolean;
};

const TermsInput: React.FC<ComponentProps> = (props) => {
  const {
    inputName = 'Terms',
    terms,
    onChange,
    onDelete,
    enableGenerate = false,
    // enableImport = false,
    useDisabledColor = false,
    required = true,
  } = props;
  const dispatch = useDispatch();

  const generatedTerms = useSelector(getGeneratedTerms);
  const generateTermsLoading = useSelector(getGeneratedTermsLoading);

  const [term, setTerm] = useState('');

  // const fileInputEl = useRef<HTMLInputElement>(null);
  // const [fileData, setFileData] = React.useState<Record<string, string>[] | null>([]);

  // @ts-ignore
  /* const formatedFileData = fileData?.reduce<Record<string, string[]>>((acc, item) => {
    Object.entries(item).forEach(([key, value]) => {
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(value);
    });
    return acc;
  }, {}); */

  /* useEffect(() => {
    if (formatedFileData && Object.keys(formatedFileData).length) {
      dispatch(editTermsValues([...terms, ...[...new Set(formatedFileData.terms)]]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(fileData)]); */

  /* const handleFileClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    e.stopPropagation();

    if (fileInputEl.current != null) {
      fileInputEl.current.click();
    }
  }; */

  /* const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const fileReader = new FileReader();
    if (e.target.files != null) {
      fileReader.readAsText(e.target.files[0], 'UTF-8');
      fileReader.onload = (event): void => {
        if (event.target != null && event.target.result != null) {
          const parsed = PapaParse.parse(event.target.result as string, {
            header: true,
            skipEmptyLines: true,
          });
          setFileData(parsed.data as Record<string, string>[]);
        }
      };
    }
  }; */

  const handleGenerateTerms = (): void => {
    if (terms) {
      dispatch(
        generateTerms({
          includedTerms: [...terms],
        })
      );
    }
  };

  const handleAddSuggestedTerm = (t: string): void => {
    onChange(t);
  };

  const filteredGeneratedTerms = [...new Set(generatedTerms.map((t) => t.toLowerCase()))].filter(
    (t) => terms && !terms.map((ter) => ter.toLowerCase()).includes(t.toLowerCase())
  );

  const renderedGeneratedTerms = (): JSX.Element => {
    if (generatedTerms.length > 0 && filteredGeneratedTerms.length === 0) {
      return <span className="text-small">No new suggestions</span>;
    }

    return (
      <>
        {filteredGeneratedTerms.map((t: string) => (
          <button
            type="button"
            key={t}
            className="rounded px-1 py-0.5 bg-litlingo-gray-1 text-small focus:outline-none"
            onClick={(): void => handleAddSuggestedTerm(t)}
          >
            {t}
          </button>
        ))}
      </>
    );
  };

  const handleSubmit = (): void => {
    onChange(term);
    setTerm('');
  };

  const keyPressed = (e: React.KeyboardEvent<HTMLTextAreaElement>): void => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="w-full flex flex-col gap-2">
      <div>
        <div className="flex flex-row">
          <span>{inputName}</span>
          {required && <span className="text-litlingo-alert">*</span>}
        </div>

        <div className="flex">
          <div className="relative flex-grow focus-within:z-10">
            <textarea
              name="term"
              rows={1}
              className="form-input block w-full border-r-0 border-litlingo-gray-2  rounded-l-lg rounded-r-none text-body"
              value={term}
              onChange={(e): void => setTerm(e.target.value)}
              onKeyPress={(e): void => keyPressed(e)}
              onBlur={handleSubmit}
            />
          </div>
          <button
            type="button"
            onClick={handleSubmit}
            className="flex justify-center items-center border border-l-0 border-litlingo-gray-2 rounded-r-lg bg-litlingo-gray-1 focus:outline-none"
          >
            <span className="px-1.5">{PLUS_ADD_FIELD_ICON}</span>
          </button>
        </div>
      </div>

      {terms && (
        <div className="flex flex-wrap gap-1">
          {terms
            .slice()
            .sort((a, b) => (a.toLowerCase() < b.toLowerCase() ? -1 : 1))
            .map((t) => (
              <TermPill
                key={t}
                term={t}
                deleteTerm={onDelete}
                useDisabledColor={useDisabledColor}
              />
            ))}
        </div>
      )}

      {enableGenerate && (
        <div className="flex flex-row gap-2 justify-between pt-1 border-t border-litlingo-gray-1">
          <div className="flex flex-row flex-wrap gap-1">{renderedGeneratedTerms()}</div>

          <div className="flex flex-row gap-2 flex-no-wrap">
            <button
              type="button"
              className="button button--secondary text-body h-6 w-24 justify-center px-4"
              onClick={handleGenerateTerms}
              disabled={!terms || terms.length === 0}
            >
              <span className="whitespace-no-wrap font-bold">
                {generateTermsLoading ? <LoadingIndicator size="3" /> : 'Generate'}
              </span>
            </button>

            {/* {enableImport && (
              <div className="rounded-md">
                <input
                  ref={fileInputEl}
                  type="file"
                  accept=".csv"
                  onChange={handleFileChange}
                  style={{ position: 'fixed', top: '-100em' }}
                />
                <button
                  type="button"
                  onClick={handleFileClick}
                  className="button button--secondary text-body h-6 w-20 justify-center px-4"
                  data-testid="import-button"
                >
                  <span className="whitespace-no-wrap font-bold">Import</span>
                </button>
              </div>
            )} */}
          </div>
        </div>
      )}
    </div>
  );
};

export default TermsInput;
